import React from 'react'
import {
  Col,
  Row,
} from "react-bootstrap";
import { RadialBarChart, RadialBar } from "recharts";
import Card from 'react-bootstrap/Card';

const data = [
  {
    name: "40-49",
    uv: 2.63,
    pv: 1000,
    fill: "#A9CF4B"
  },
  {
    name: "50+",
    uv: 4.63,
    pv: 4800,
    fill: "#E66100"
  },
  {
    name: "unknow",
    uv: 6.67,
    pv: 4800,
    fill: "#468BDD"
  }
];



const CouponsSummary = (props) => {
  const {summaryData} = props;
  return (
    <>
      <p className="page-maintitle mt-4">Coupons Summary</p>
      <Row className='vou-card-main py-4 px-2 CoupSumm'>
        {/* <Col className='barchat-sec'>
        <RadialBarChart
              width={200}
              height={200}
              cx={100}
              cy={100}
              innerRadius={50}
              outerRadius={100}
              barSize={8}
              data={data}
            >
              <RadialBar
                minAngle={15}
                background
                clockWise
                dataKey="uv"
              />
            </RadialBarChart>
        </Col> */}
        {/* <Col>
        <Card className='gray-vou-card'>
          <Card.Header as="h5"></Card.Header>
          <Card.Body>
            <Card.Title>Total Count Of Available Coupons</Card.Title>
            <Card.Text>
              {summaryData['total_coupons']}
            </Card.Text>
          </Card.Body>
        </Card> 
        </Col> */}
          <Card className='blue-vou-card'>
            <Card.Header as="h5"></Card.Header>
            <Card.Body>
              <Card.Title>Downloaded Coupons</Card.Title>
              <Card.Text>
              {summaryData['downloaded_coupons']}
              </Card.Text>
            </Card.Body>
          </Card> 
          <Card className='orange-vou-card'>
              <Card.Header as="h5"></Card.Header>
              <Card.Body>
                <Card.Title>Redeemed Coupons</Card.Title>
                <Card.Text>
                {summaryData['coupons_redeemed']}
                </Card.Text>
              </Card.Body>
            </Card>
          <Card className='green-vou-card'>
              <Card.Header as="h5"></Card.Header>
              <Card.Body>
                <Card.Title>Unredeemed Coupons</Card.Title>
                <Card.Text>
                {summaryData['un_redeemed_coupons']}
                </Card.Text>
              </Card.Body>
            </Card>
      </Row>

    </>
  )
}

export default CouponsSummary